/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { UsersServicesLiesGridDto } from './UsersServicesLiesGridDto';
import {
    UsersServicesLiesGridDtoFromJSON,
    UsersServicesLiesGridDtoFromJSONTyped,
    UsersServicesLiesGridDtoToJSON,
} from './UsersServicesLiesGridDto';

/**
 * 
 * @export
 * @interface UsersServicesLiesGridDtoPaginatedResults
 */
export interface UsersServicesLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof UsersServicesLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<UsersServicesLiesGridDto>}
     * @memberof UsersServicesLiesGridDtoPaginatedResults
     */
    results?: Array<UsersServicesLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof UsersServicesLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the UsersServicesLiesGridDtoPaginatedResults interface.
 */
export function instanceOfUsersServicesLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UsersServicesLiesGridDtoPaginatedResultsFromJSON(json: any): UsersServicesLiesGridDtoPaginatedResults {
    return UsersServicesLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function UsersServicesLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsersServicesLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(UsersServicesLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function UsersServicesLiesGridDtoPaginatedResultsToJSON(value?: UsersServicesLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(UsersServicesLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

